import {
  NO,
  getPhoneValue,
  getYesNoValue,
  getTrackerAgreement,
  getLastNameValue,
  getFirstNameValue,
  getYesNoValueProxy,
  getOneCircumstanceFromMultiProxy,
  getOneFromMultiProxy,
  getDateValueProxy,
  arrayIncludesValueProxy,
  arrayIncludesKeyAndValueProxy,
  getCountryCode,
  getLicenseNumber,
  getSpecialLicenseNumber,
  stripSpacesFromIban,
  getDescribeCircumstance,
  getVehicleTypeValue,
  getSalutationValue,
} from '../claimData.helpers';
import { getGuiltValue } from './claimData.helpers';
import { claimsKeys, getCarMapKey, userTypes } from '../../../helpers/formData/formData';
import { collisionAndLiabilityDamages, collisionTypes } from '../../../helpers/formData/vehicleFormData';

export default {
  'collision_event-circumstances_day': {
    date: [claimsKeys.DATE, getDateValueProxy],
  },
  'collision_event-circumstances_location': {
    location: claimsKeys.LOCATION,
    country: [claimsKeys.COUNTRY_CODE, getCountryCode],
  },
  'collision_event-circumstances_circumstances': {
    circumstance: [
      claimsKeys.KIND_OF_DAMAGE,
      getOneCircumstanceFromMultiProxy({
        invade: collisionAndLiabilityDamages.INVADE,
        entry: collisionAndLiabilityDamages.ENTRY,
        disregard: collisionAndLiabilityDamages.DISREGARD,
        turn: collisionAndLiabilityDamages.TURN,
        maneuvering: collisionAndLiabilityDamages.MANEUVERING,
        overtaking: collisionAndLiabilityDamages.OVERTAKING,
        laneChange: collisionAndLiabilityDamages.LANE_CHANGE,
        different: collisionAndLiabilityDamages.DIFFERENT,
      }),
    ],
    describeCircumstance: [claimsKeys.CIRCUMSTANCES, getDescribeCircumstance],
  },
  'collision_event-circumstances_guilt': [claimsKeys.CAUSER_OF_DAMAGE, getGuiltValue],
  // !Special case after prefilling data
  'vehicle-id-ergo_license-number': {
    part1: [claimsKeys.owner.LICENSE_NUMBER, getSpecialLicenseNumber],
    claimNumber: claimsKeys.POLICY_NUMBER,
  },
  'collision_contact-person': {
    who: [claimsKeys.owner.SALUTATION, getSalutationValue],
    firstName: [claimsKeys.owner.FIRST_NAME, getFirstNameValue],
    lastName: [claimsKeys.owner.LAST_NAME, getLastNameValue],
    phoneNumber: [claimsKeys.owner.PHONE, getPhoneValue],
    email: claimsKeys.owner.EMAIL,
    agreement: [claimsKeys.owner.TRACKER_AGREEMENT, getTrackerAgreement],
  },
  'collision_was-police-reported_is-reported': [claimsKeys.POLICE, getYesNoValue],
  'collision_was-police-reported_report-details': {
    department: claimsKeys.DEPARTMENT,
    caseNumber: claimsKeys.CASE_NUMBER,
  },
  'collision_are-there-any-witnesses_are-there-any-witnesses': [claimsKeys.ANY_WITNESS, getYesNoValue],
  'collision_are-there-any-witnesses_only-witness': {
    firstName: [claimsKeys.firstWitness.FIRST_NAME, getFirstNameValue],
    lastName: [claimsKeys.firstWitness.LAST_NAME, getLastNameValue],
    phoneNumber: [claimsKeys.firstWitness.PHONE, getPhoneValue],
  },
  'collision_are-there-any-witnesses_first-witness': {
    firstName: [claimsKeys.firstWitness.FIRST_NAME, getFirstNameValue],
    lastName: [claimsKeys.firstWitness.LAST_NAME, getLastNameValue],
    phoneNumber: [claimsKeys.firstWitness.PHONE, getPhoneValue],
  },
  'collision_are-there-any-witnesses_second-witness': {
    firstName: [claimsKeys.secondWitness.FIRST_NAME, getFirstNameValue],
    lastName: [claimsKeys.secondWitness.LAST_NAME, getLastNameValue],
    phoneNumber: [claimsKeys.secondWitness.PHONE, getPhoneValue],
  },
  'collision_are-there-any-witnesses_third-witness': {
    firstName: [claimsKeys.thirdWitness.FIRST_NAME, getFirstNameValue],
    lastName: [claimsKeys.thirdWitness.LAST_NAME, getLastNameValue],
    phoneNumber: [claimsKeys.thirdWitness.PHONE, getPhoneValue],
  },
  'collision_collision-type': [
    claimsKeys.SUB_SECTOR_INSURED_PERSON,
    getOneFromMultiProxy({
      'own-car': collisionTypes.OWN_CAR,
      'other-car-object-person': collisionTypes.OTHER_CAR_OBJECT_PERSON,
      both: collisionTypes.BOTH,
    }),
  ],
  'collision_is-ready-for-driving': [claimsKeys.IS_READY_FOR_DRIVING, getYesNoValue],
  'collision_airbags-were-deployed': [claimsKeys.AIRBAGS_WERE_DEPLOYED, getYesNoValue],
  'collision_warning-lights-activated': [claimsKeys.WARNING_LIGHTS_ACTIVATED, getYesNoValue],
  'collision_fluids-lost': [claimsKeys.FLUIDS_LOST, getYesNoValue],
  // Collision Type: Car
  'collision_my-own-vehicle-damage-description_car-map': {
    describeDamage: claimsKeys.owner.DESCRIBE_DAMAGE,
    'front-left': [getCarMapKey('front-left'), arrayIncludesKeyAndValueProxy('carMap', 'front-left')],
    'front-middle': [getCarMapKey('front-middle'), arrayIncludesKeyAndValueProxy('carMap', 'front-middle')],
    'front-right': [getCarMapKey('front-right'), arrayIncludesKeyAndValueProxy('carMap', 'front-right')],
    'middle-left': [getCarMapKey('middle-left'), arrayIncludesKeyAndValueProxy('carMap', 'middle-left')],
    'middle-part': [getCarMapKey('middle-part'), arrayIncludesKeyAndValueProxy('carMap', 'middle-part')],
    'middle-right': [getCarMapKey('middle-right'), arrayIncludesKeyAndValueProxy('carMap', 'middle-right')],
    'back-left': [getCarMapKey('back-left'), arrayIncludesKeyAndValueProxy('carMap', 'back-left')],
    'back-middle': [getCarMapKey('back-middle'), arrayIncludesKeyAndValueProxy('carMap', 'back-middle')],
    'back-right': [getCarMapKey('back-right'), arrayIncludesKeyAndValueProxy('carMap', 'back-right')],
  },
  'collision_car-repair_private-vehicle': [claimsKeys.PRIVATE_VEHICLE, getYesNoValueProxy(NO)],
  'collision_car-repair_is-repaired': [claimsKeys.IS_REPAIRED, getYesNoValue],
  'collision_car-repair_customer-services_use-kva-service': [claimsKeys.USE_KVA_SERVICE, getYesNoValue],
  'collision_car-repair_customer-services_select-workshop': {
    name: claimsKeys.KVA_SERVICE_WORKSHOP_NAME,
    address: claimsKeys.KVA_SERVICE_WORKSHOP_ADDRESS,
    city: claimsKeys.KVA_SERVICE_WORKSHOP_CITY,
    postalcode: claimsKeys.KVA_SERVICE_WORKSHOP_PLZ,
  },
  'collision_car-repair_repaired-beneficiary-iban_payment': [
    claimsKeys.BANK_ACCOUNT,
    getOneFromMultiProxy({
      'my-account': claimsKeys.MY_ACCOUNT,
      'another-account': claimsKeys.ANOTHER_ACCOUNT,
    }),
  ],
  'collision_car-repair_repaired-beneficiary-iban_name': {
    name: claimsKeys.IBAN_NAME,
    iban: [claimsKeys.IBAN, stripSpacesFromIban],
  },
  'collision_bike-other': claimsKeys.DAMAGED_PARTS,
  'collision_car-repair_use-calculation-app': [claimsKeys.USE_CALCULATION_APP, getYesNoValue],
  'collision_vehicle-type': [claimsKeys.VEHICLE_TYPE, getOneFromMultiProxy({
    car: claimsKeys.vehicleType.CAR,
    truck: claimsKeys.vehicleType.TRUCK,
    motorcycle: claimsKeys.vehicleType.MOTORCYCLE,
    other: claimsKeys.vehicleType.OTHER,
  })],
  'collision_car-repair_have-you-invoices': [claimsKeys.INVOICES, getYesNoValue],
  'collision_car-repair_repaired-repair-shop': {
    name: claimsKeys.REPAIR_SHOP_NAME,
    phoneNumber: [claimsKeys.WORKSHOP_PHONE, getPhoneValue],
    city: claimsKeys.WORKSHOP_CITY,
  },
  'collision_car-repair_want-to-repair': [
    claimsKeys.DAMAGE_REPAIR,
    getOneFromMultiProxy({
      yes: claimsKeys.REPAIR,
      no: claimsKeys.PAYOUT,
    }),
  ],
  'collision_car-repair_not-repaired-beneficiary-iban_payment': [
    claimsKeys.BANK_ACCOUNT,
    getOneFromMultiProxy({
      'my-account': claimsKeys.MY_ACCOUNT,
      'another-account': claimsKeys.ANOTHER_ACCOUNT,
    }),
  ],
  'collision_car-repair_not-repaired-beneficiary-iban_name': {
    name: claimsKeys.IBAN_NAME,
    iban: [claimsKeys.IBAN, stripSpacesFromIban],
  },
  'collision_car-repair_want-to-recommend-repair-shop': [claimsKeys.RECOMMEND_REPAIR_SHOP, getYesNoValue],
  'collision_car-repair_not-repaired-repair-shop': {
    name: claimsKeys.REPAIR_SHOP_NAME,
    phoneNumber: [claimsKeys.WORKSHOP_PHONE, getPhoneValue],
    city: claimsKeys.WORKSHOP_CITY,
  },
  'collision_car-repair_is-vehicle-in-workshop': [claimsKeys.WORKSHOP, getYesNoValue],
  'collision_car-repair_postal-code': claimsKeys.WORKSHOP_POSTAL_CODE,
  'collision_car-repair_select-workshop': {
    name: claimsKeys.REPAIR_SHOP_NAME,
    address: claimsKeys.WORKSHOP_ADDRESS,
    phone: claimsKeys.WORKSHOP_PHONE,
    city: claimsKeys.WORKSHOP_CITY,
    postalcode: claimsKeys.WORKSHOP_POSTAL_CODE,
    wspid: claimsKeys.WSPID_WORKSHOP,
  },
  // Collision Type: Other
  'collision_third-contact-person': {
    who: [claimsKeys.thirdParty.SALUTATION, getSalutationValue],
    firstName: [claimsKeys.thirdParty.FIRST_NAME, getFirstNameValue],
    lastName: [claimsKeys.thirdParty.LAST_NAME, getLastNameValue],
    phoneNumber: [claimsKeys.thirdParty.PHONE, getPhoneValue],
  },
  'collision_third-location': {
    address: claimsKeys.thirdParty.ADDRESS,
    postCode: claimsKeys.thirdParty.POST_CODE,
    city: claimsKeys.thirdParty.CITY,
    country: [claimsKeys.thirdParty.COUNTRY_CODE, getCountryCode],
  },
  'collision_third-party-who-what-has-suffered': {
    'personal-injury': [claimsKeys.thirdParty.PERSONAL_INJURY, arrayIncludesValueProxy('personal-injury')],
    'item-damage': [claimsKeys.thirdParty.ITEM_DAMAGE, arrayIncludesValueProxy('item-damage')],
    'vehicle-damage': [claimsKeys.thirdParty.VEHICLE_DAMAGE, arrayIncludesValueProxy('vehicle-damage')],
  },
  'collision_third-party-specify-personal-injury': claimsKeys.thirdParty.PERSONAL_INJURY_DESC,
  'collision_third-party-specify-item-damage': claimsKeys.thirdParty.ITEM_DAMAGE_DESC,
  'collision_third-party-vehicle-id-non-ergo-by-collision_vehicle-type': [
    claimsKeys.thirdParty.VEHICLE_TYPE,
    getVehicleTypeValue,
  ],
  'collision_third-party-vehicle-id-non-ergo-by-collision_license-number': [
    claimsKeys.thirdParty.LICENSE_NUMBER,
    getLicenseNumber,
  ],
  'collision_third-party-vehicle-id-non-ergo-by-collision_bike-other': claimsKeys.thirdParty.DESCRIBE_DAMAGE,
  'collision_third-party-vehicle-id-non-ergo-by-collision_vehicle-damage-description_car-map': {
    describeDamage: claimsKeys.thirdParty.DESCRIBE_DAMAGE,
    'front-left': [
      getCarMapKey('front-left', userTypes.THIRD_PARTY),
      arrayIncludesKeyAndValueProxy('carMap', 'front-left'),
    ],
    'front-middle': [
      getCarMapKey('front-middle', userTypes.THIRD_PARTY),
      arrayIncludesKeyAndValueProxy('carMap', 'front-middle'),
    ],
    'front-right': [
      getCarMapKey('front-right', userTypes.THIRD_PARTY),
      arrayIncludesKeyAndValueProxy('carMap', 'front-right'),
    ],
    'middle-left': [
      getCarMapKey('middle-left', userTypes.THIRD_PARTY),
      arrayIncludesKeyAndValueProxy('carMap', 'middle-left'),
    ],
    'middle-part': [
      getCarMapKey('middle-part', userTypes.THIRD_PARTY),
      arrayIncludesKeyAndValueProxy('carMap', 'middle-part'),
    ],
    'middle-right': [
      getCarMapKey('middle-right', userTypes.THIRD_PARTY),
      arrayIncludesKeyAndValueProxy('carMap', 'middle-right'),
    ],
    'back-left': [
      getCarMapKey('back-left', userTypes.THIRD_PARTY),
      arrayIncludesKeyAndValueProxy('carMap', 'back-left'),
    ],
    'back-middle': [
      getCarMapKey('back-middle', userTypes.THIRD_PARTY),
      arrayIncludesKeyAndValueProxy('carMap', 'back-middle'),
    ],
    'back-right': [
      getCarMapKey('back-right', userTypes.THIRD_PARTY),
      arrayIncludesKeyAndValueProxy('carMap', 'back-right'),
    ],
  },
};
